import { defineMessages } from 'react-intl';

const translations = {
  fields: {
    name: {
      label: {
        id: 'properties.name',
        defaultMessage: 'Name',
        description: 'The label of the name field in the pricing rule form',
      },
    },
    type: {
      label: {
        id: 'properties.type',
        defaultMessage: 'Type',
        description: 'The label of the type field in the pricing rule form',
      },
    },
    applyTo: {
      label: {
        id: 'properties.applyTo',
        defaultMessage: 'Apply to',
        description: 'The label of the apply to field in the pricing rule form',
      },
    },
    grantLimit: {
      label: {
        id: 'properties.grantLimit',
        defaultMessage: 'Grant limit',
        description: 'label of the form field grant limit',
      },
    },
    priority: {
      label: {
        id: 'properties.priority',
        defaultMessage: 'Priority',
        description: 'label of the form field priority',
      },
    },
    activeAt: {
      label: {
        id: 'properties.activeAt',
        defaultMessage: 'Active at',
        description: 'label of the form field active at',
      },
    },
    expiresAt: {
      label: {
        id: 'properties.expiresAt',
        defaultMessage: 'Expires at',
        description: 'label of the form field expires at',
      },
    },
    isLastRule: {
      label: {
        id: 'properties.isLastRule',
        defaultMessage: 'Use as last rule',
        description: 'label of the form field is last rule',
      },
    },
  },
  types: {
    enhanced: {
      id: 'pricingRuleForm.types.enhanced',
      defaultMessage: 'Enhanced',
      description: 'Label of the pricing rule type enhanced',
    },
    coupon: {
      id: 'pricingRuleForm.types.coupon',
      defaultMessage: 'Coupon',
      description: 'Label of the pricing rule type coupon',
    },
    shippingCosts: {
      id: 'pricingRuleForm.types.shippingCosts',
      defaultMessage: 'Shipping costs',
      description: 'Label of the pricing rule type shipping costs',
    },
  },
  applyToOptions: {
    linesHandling: {
      id: 'pricingRuleForm.applyToOptions.linesHandling',
      defaultMessage: 'Lines handling',
      description: 'label of the form field lines handling',
    },
    linesShipping: {
      id: 'pricingRuleForm.applyToOptions.linesShipping',
      defaultMessage: 'Lines shipping',
      description: 'label of the form field lines shipping',
    },
    linesCheapest: {
      id: 'pricingRuleForm.applyToOptions.linesCheapest',
      defaultMessage: 'Lines cheapest',
      description: 'label of the form field lines cheapest',
    },
    linesAll: {
      id: 'pricingRuleForm.applyToOptions.linesAll',
      defaultMessage: 'Lines all',
      description: 'label of the form field lines all',
    },
    filterResult: {
      id: 'pricingRuleForm.applyToOptions.filterResult',
      defaultMessage: 'Filter result',
      description: 'label of the form field filter result',
    },
    filterCheapest: {
      id: 'pricingRuleForm.applyToOptions.filterCheapest',
      defaultMessage: 'Filter cheapest',
      description: 'label of the form field filter cheapest',
    },
  },
};

export default defineMessages(translations);
